// extracted by mini-css-extract-plugin
module.exports = {"post_share_toast_wrap":"Toast_post_share_toast_wrap__kL2ep","-show":"Toast_-show__NIHIt","post_share_toast_text":"Toast_post_share_toast_text__zoQSa"};